'use client';
var styles = {"article":"HeaderBrandWindow-module_article__Y75VN","npay-wrapper":"HeaderBrandWindow-module_npay-wrapper__EwdkE","title":"HeaderBrandWindow-module_title__Bc99Z","has-tooltip":"HeaderBrandWindow-module_has-tooltip__DRZke","button-tooltip":"HeaderBrandWindow-module_button-tooltip__Z0pWc"};

export { styles as default };
